import React, { ReactElement, useState } from "react";
import { Permission, useCreateTokenMutation } from "../../__generated__/api";
import CodeBlock from "../code-block/CodeBlock";

import Styles from "./CreateToken.module.scss";

interface Props {
    permissions: Permission[];
    name: string;
    buttonText?: string
}

export default function CreateToken({
    permissions, name, buttonText,
}: Props): ReactElement {
    const [token, setToken] = useState("");
    const [getToken] = useCreateTokenMutation();

    const createToken = async () => {
        const createdToken = await getToken({
            variables: {
                token: {
                    permissions,
                    name,
                },
            },
        });

        setToken(createdToken.data?.createToken.token as string);
    };
    return (
        <div>
            {token ? (
                <div className={`border p-4 mt-4 rounded ${Styles.token}`}>
                    <p className="mb-2 fw-semibold">
                        This token will only display here now. Once you navigate away, you will be unable to be
                        retrieved again without creating a new token. Please store it in a safe space.
                    </p>
                    <CodeBlock code={token} isCopyable size="sm" />

                </div>
            ) : (
                <button
                    type="button"
                    className="btn btn-info text-white"
                    onClick={createToken}
                >
                    {buttonText}
                </button>
            )}
        </div>
    );
}

CreateToken.defaultProps = {
    buttonText: "Create Token",
};
